import { render } from "./App.vue?vue&type=template&id=c6225c82&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=c6225c82&lang=scss"

import exportComponent from "/home/mateusz/Workspace/Planer Ślubu/planer-slubu-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__